// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewAcuityEyesResponse } from './rapid-review-acuity-eyes-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewAcuityResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewAcuityResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: RapidReviewAcuityEyesResponse })
	distanceVa!: RapidReviewAcuityEyesResponse | null;

	@GandalfProperty({ designType: String })
	nearDistanceVa!: string | null;

	@GandalfProperty({ designType: RapidReviewAcuityEyesResponse })
	nearVa!: RapidReviewAcuityEyesResponse | null;

	@GandalfProperty({ designType: RapidReviewAcuityEyesResponse })
	pinholeVa!: RapidReviewAcuityEyesResponse | null;

	@GandalfProperty({ designType: String })
	rxWorn!: string | null;

	@GandalfProperty({ designType: String })
	vaMethod!: string | null;

	@GandalfProperty({ designType: Number })
	workflowTestId!: number;

}
